import {Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {FX} from 'app/core/domain/fx';
import {FxService} from '../../../core/service/fx.service';
import {Subject} from 'rxjs/Subject';

@Component({
    selector: 'fxs-picker',
    templateUrl: './fxs-picker.component.html',
    styleUrls: ['./fxs-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FxsPickerComponent implements OnInit {

    _fxs: FX[] = [];

    _fxsSelected: FX[] = [];

    private readyToFilter = false;

    @Output() fxsSelectedChange = new EventEmitter<FX[]>();

    private $fxsSelected: Subject<FX[]> = new Subject();

    constructor(private fxService: FxService,
                private cd: ChangeDetectorRef) {
    }

    @Input()
    set fxsSelected(fxs: FX[]) {
        this._fxsSelected = fxs;
        this.$fxsSelected.next(fxs);
    }

    get fxsSelected(): FX[] {
        return this._fxsSelected;
    }

    ngOnInit() {
        this.fxService.getAll().subscribe(fxs => {
            this.$fxsSelected.subscribe(selectedFXs => {
                    if (selectedFXs.length > 0) {
                        this._fxs = fxs
                            .filter(fx => !selectedFXs.some(f => fx.id === f.id));
                    }else {
                        this._fxs = fxs;
                    }
                    this._fxsSelected = selectedFXs;
                    this.cd.markForCheck();
                }
            );
            this.$fxsSelected.next(this._fxsSelected);
        })
    }

    public addFx(fx) {
        this._fxsSelected = this._fxsSelected.concat([new FX(fx)]);
        this.fxsSelectedChange.emit(this._fxsSelected);
        this.cd.markForCheck();
    }

    public removeFx(fx) {
        this._fxs = this._fxs.concat([new FX(fx)]);
        this.fxsSelectedChange.emit(this._fxsSelected);
        this.cd.markForCheck();
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/fxs/fxs-picker/fxs-picker.component.ts